import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RecruitmentService } from '../recruitment/recruitment.service';
import { RecruitmentActivitesAdapter } from './dto/recruitment-activities.adapter';
import { RecruitmentActivities } from './entity/recruitment-activities.entity';
import { RecruitmentActivitiesController } from './recruitment-activities.controller';
import { RecruitmentActivitiesService } from './recruitment-activities.service';

@Module({
  imports:[
    TypeOrmModule.forFeature([RecruitmentActivities])
  ],
  controllers: [RecruitmentActivitiesController],
  providers: [RecruitmentActivitiesService,RecruitmentActivitesAdapter,ApplicationExceptionHandler],
  exports:[RecruitmentActivitiesService]
})
export class RecruitmentActivitiesModule {}
